export const THEME_STORAGE_KEY = 'investportpro_theme';
export const LEGACY_DARKMODE_STORAGE_KEY = 'investportpro_darkmode';

export const THEME_TOKENS = {
  light: {
    'color-text-primary': '#0f172a',
    'color-text-secondary': '#475569',
    'color-text-muted': '#64748b',
    'color-text-inverse': '#f8fafc',
    'color-background': '#f8fafc',
    'color-surface': '#ffffff',
    'color-surface-muted': '#f1f5f9',
    'color-surface-elevated': '#ffffff',
    'color-accent': '#2563eb',
    'color-accent-strong': '#1d4ed8',
    'color-accent-soft': 'rgba(37, 99, 235, 0.12)',
    'color-border': '#dbe3ef',
    'color-border-muted': '#e2e8f0',
    'color-success': '#059669',
    'color-success-soft': 'rgba(5, 150, 105, 0.14)',
    'color-error': '#dc2626',
    'color-error-soft': 'rgba(220, 38, 38, 0.12)',
    'color-warning': '#d97706',
    'color-warning-soft': 'rgba(217, 119, 6, 0.14)',
    'color-header-bg': '#0f172a',
    'color-header-surface': 'rgba(255, 255, 255, 0.1)',
    'color-header-surface-hover': 'rgba(255, 255, 255, 0.18)',
    'color-header-text': '#f8fafc',
    'color-header-text-muted': '#cbd5e1',
    'color-overlay': 'rgba(15, 23, 42, 0.6)',
    'color-hero-from': '#2563eb',
    'color-hero-via': '#4f46e5',
    'color-hero-to': '#7c3aed',
    'shadow-surface': '0 18px 50px rgba(15, 23, 42, 0.08)',
    'shadow-soft': '0 10px 30px rgba(15, 23, 42, 0.06)',
    'shadow-accent': '0 14px 35px rgba(37, 99, 235, 0.28)'
  },
  dark: {
    'color-text-primary': '#e2e8f0',
    'color-text-secondary': '#cbd5e1',
    'color-text-muted': '#94a3b8',
    'color-text-inverse': '#f8fafc',
    'color-background': '#020617',
    'color-surface': '#0f172a',
    'color-surface-muted': '#111827',
    'color-surface-elevated': '#1e293b',
    'color-accent': '#60a5fa',
    'color-accent-strong': '#3b82f6',
    'color-accent-soft': 'rgba(96, 165, 250, 0.18)',
    'color-border': '#334155',
    'color-border-muted': '#1e293b',
    'color-success': '#34d399',
    'color-success-soft': 'rgba(52, 211, 153, 0.16)',
    'color-error': '#f87171',
    'color-error-soft': 'rgba(248, 113, 113, 0.16)',
    'color-warning': '#fbbf24',
    'color-warning-soft': 'rgba(251, 191, 36, 0.16)',
    'color-header-bg': '#020617',
    'color-header-surface': 'rgba(148, 163, 184, 0.12)',
    'color-header-surface-hover': 'rgba(148, 163, 184, 0.2)',
    'color-header-text': '#f8fafc',
    'color-header-text-muted': '#cbd5e1',
    'color-overlay': 'rgba(2, 6, 23, 0.72)',
    'color-hero-from': '#1d4ed8',
    'color-hero-via': '#4338ca',
    'color-hero-to': '#6d28d9',
    'shadow-surface': '0 18px 50px rgba(2, 6, 23, 0.42)',
    'shadow-soft': '0 10px 30px rgba(2, 6, 23, 0.32)',
    'shadow-accent': '0 14px 35px rgba(59, 130, 246, 0.24)'
  }
};

export const isThemeMode = (value) => value === 'light' || value === 'dark';
export const isDarkTheme = (value) => value === 'dark';

export const getInitialTheme = () => {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  const savedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (isThemeMode(savedTheme)) {
    return savedTheme;
  }

  const legacyValue = window.localStorage.getItem(LEGACY_DARKMODE_STORAGE_KEY);
  if (legacyValue !== null) {
    try {
      return JSON.parse(legacyValue) ? 'dark' : 'light';
    } catch (_error) {
      return legacyValue === 'true' ? 'dark' : 'light';
    }
  }

  return 'dark';
};

export const persistTheme = (themeMode) => {
  if (typeof window === 'undefined' || !isThemeMode(themeMode)) {
    return;
  }

  window.localStorage.setItem(THEME_STORAGE_KEY, themeMode);
  window.localStorage.setItem(LEGACY_DARKMODE_STORAGE_KEY, JSON.stringify(themeMode === 'dark'));
};

export const applyTheme = (themeMode) => {
  if (typeof document === 'undefined' || !isThemeMode(themeMode)) {
    return;
  }

  const root = document.documentElement;
  const tokens = THEME_TOKENS[themeMode];

  root.dataset.theme = themeMode;
  root.classList.toggle('dark', themeMode === 'dark');
  root.style.colorScheme = themeMode;

  Object.entries(tokens).forEach(([token, value]) => {
    root.style.setProperty(`--${token}`, value);
  });

  // Update mobile status bar color (iOS Safari + Android Chrome)
  const themeColorMeta = document.getElementById('theme-color-meta');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', themeMode === 'dark' ? '#020617' : '#f8fafc');
  }
};
